export function setContentPadding () {
  const $content = document.getElementById("content")
  const $header = document.getElementById("header")
  const $headerfilters = document.getElementById("header-filters")

  $content.style.paddingTop =
    $header.offsetHeight + $headerfilters.offsetHeight + 10 + "px"
}
